import React from 'react';
import { useCommon } from '../../store/CommonContext';
import Loader from '../../components/loader/Loader';
import { FONT_FAMILY, MODAL_BORDER_RADIUS } from '../../components/constants/style-constants';
import Logo from '../../components/logo/Logo';
import Content from '../../components/blocks/Content';
import Title from '../../components/text/Title';
import HorizontalLine from '../../components/decorations/lines/HorizontalLine';
import List from '../../components/list/List';
import ListItem from '../../components/list/ListItem';
import Button from '../../components/buttons/Button';
import { redirectToSuccess } from '../../helpers/parent-helper';
import Terms from '../../components/text/Terms';

import './SuccessExplanation.css';

interface Props {}

const SuccessExplanation: React.FC<Props> = () => {
  const {
    state: { configurationLoading, orderDataLoading, configuration, orderData },
  } = useCommon();
  const amount =
    orderData?.amount && !isNaN(Number((orderData?.amount / 100).toFixed(2)))
      ? Number((orderData?.amount / 100).toFixed(2))
      : '';

  const handleClick = (): void => {
    redirectToSuccess();
  };

  if (configurationLoading || orderDataLoading) {
    return <Loader />;
  }

  return (
    <div
      className="success-explanation dialog"
      style={{
        ...(configuration?.fontFamily && { fontFamily: configuration.fontFamily as string }),
        ...(configuration?.modalCornersRadius && { borderRadius: configuration.modalCornersRadius as string }),
      }}
    >
      <Logo imageUrl="https://portal.flex-charge.com/media/flex-logo-small.png" />
      <Content>
        <>
          <Title
            text={`Your payment of ${
              orderData?.currencySymbol || ''
            }${amount} has failed but no worries, your purchase was completed anyway!`}
          />
          {/*<HorizontalLine />*/}
          <List>
            <>
              {/*<ListItem>*/}
              {/*  <span className="ui-widget-item-bold">Your purchase was completed anyway</span>*/}
              {/*</ListItem>*/}
              <ListItem>
                <>
                  You will be charged {orderData?.currencySymbol || ''}
                  {amount} when the issue with your payment gets resolved
                </>
              </ListItem>
              <ListItem>
                <>
                  You will be charged {orderData?.currencySymbol || ''}
                  {amount} only. <br />
                  <span className="ui-widget-item-bold">No interest, no fees. Ever.</span>
                </>
              </ListItem>
            </>
          </List>
        </>
      </Content>
      {/*<HorizontalLine />*/}
      <Terms />
      <Button text="OK" disabled={false} onClick={handleClick} additionalClasses="margin-bottom-15" />
      {/*<Copyright />*/}
    </div>
  );
};

export default SuccessExplanation;
